import type { RunLimitEntity } from '@platform/timeline';
import { registerSem, type SemCmd } from '../registry';

registerSem('run.limit.exceeded', ({ ev, now, convId }): SemCmd => {
  const data = (ev as any).data || {};
  const maxIterations = typeof data.max_iterations === 'number' ? data.max_iterations : undefined;
  const iterations = typeof data.iterations === 'number' ? data.iterations : undefined;
  const summary = typeof data.summary === 'string' ? data.summary : undefined;
  const profileSlug = typeof data.profile_slug === 'string' ? data.profile_slug : undefined;

  const ent: RunLimitEntity = {
    id: ev.id || `run-limit-${now}`,
    kind: 'run_limit',
    timestamp: now,
    props: {
      maxIterations,
      iterations,
      summary,
      profileSlug,
      convId,
    },
  };
  return { kind: 'add', convId, entity: ent };
});
